import * as Sentry from '@sentry/nextjs';
import Script from 'next/script';
import React from 'react';

const GoogleTag = () => {
  const GTM_ID = 'AW-11123463471';
  return (
    <>
      <Script async src={`https://www.googletagmanager.com/gtag/js?id=${GTM_ID}`} />
      <Script>
        {`
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', '${GTM_ID}');
        `}
      </Script>
    </>
  );
};

type GAdParameters = Partial<{
  transaction_id?: string,
  value: number,
  currency: string,
}>;

export const trackGAdsConversionEvent = (eventId: string, parameters?: GAdParameters) => {
  if (typeof window === 'undefined') return;
  // @ts-ignore
  const { gtag } = window;
  if (!gtag) return;

  try {
    gtag('event', 'conversion', {
      send_to: eventId,
      ...parameters,
    });
    return true;
  } catch (error) {
    Sentry.captureException(error, {
      contexts: {
        google_ads_data: {
          ...parameters,
        },
      },
    });
    return false;
  }
};

export default GoogleTag;
